const CompanyData = [
  {
    name: "Bring Grow",
    location: "Montenegro",
    phone: "+38268051448",
    opentime: "Mon-Sun: 13:30 - 20:30",
    facebook: "https://www.facebook.com",
    instagram: "https://www.instagram.com",
    youtube: "https://www.youtubbe.com",
    tiktok: "https://www.tiktok.com",
  },
];

export default CompanyData;
